export default __webpack_public_path__ + "static/media/logo_bottom.efa6d4ff.svg";